import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faCalendarCheck,
  faClock,
  faExclamationTriangle,
  faReceipt,
  faTag,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

import css from './BookingModal.module.css';

function BookingModal(props) {
  const { handleBookingSubmit, currentListing, onClose, providerId, onGetProviderSyncStatus } = props;
  const [count, setCount] = useState(1);
  const [syncStatus, setSyncStatus] = useState(null);

  useEffect(() => {
    if (!providerId || !onGetProviderSyncStatus) return;
    let cancelled = false;
    onGetProviderSyncStatus(providerId)
      .then(res => {
        if (!cancelled) setSyncStatus(res.data && res.data.status);
      })
      .catch(() => {
        if (!cancelled) setSyncStatus(null);
      });
    return () => {
      cancelled = true;
    };
  }, [providerId, onGetProviderSyncStatus]);
  const unitPrice =
    currentListing &&
    currentListing.attributes &&
    currentListing.attributes.price &&
    currentListing.attributes.price.amount / 100;
  const listingTitle = currentListing && currentListing.attributes && currentListing.attributes.title;
  const total = (count * unitPrice).toFixed(2);

  const countUp = () => setCount(count + 1);
  const countDown = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  return (
    <div className={css.base}>
      <div className={css.header}>
        {onClose && (
          <button type="button" className={css.closeBtn} onClick={onClose} aria-label="Close">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
        <div className={css.headerIcon}>
          <FontAwesomeIcon icon={faCalendarCheck} />
        </div>
        <h2 className={css.headerTitle}>Book your session</h2>
        {listingTitle && <p className={css.headerSubtitle}>{listingTitle}</p>}
      </div>

      <div className={css.body}>
        {syncStatus === 'not_synced' && (
          <div className={css.syncWarning}>
            <FontAwesomeIcon icon={faExclamationTriangle} className={css.syncWarningIcon} />
            This coach's calendar isn't syncing right now — their availability shown here may not be current.
          </div>
        )}
        <div className={css.infoList}>
          <div className={css.infoCard}>
            <div className={css.infoIcon}>
              <FontAwesomeIcon icon={faTag} />
            </div>
            <div className={css.infoBody}>
              <div className={css.infoTitle}>Price per hour</div>
              <div className={css.infoDesc}>Standard rate for this program</div>
            </div>
            <span className={css.infoValue}>${unitPrice}</span>
          </div>

          <div className={css.infoCard}>
            <div className={css.infoIcon}>
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className={css.infoBody}>
              <div className={css.infoTitle}>Number of hours</div>
              <div className={css.infoDesc}>Choose how many hours to book</div>
            </div>
            <div className={css.incDec}>
              <button
                type="button"
                className={css.stepBtn}
                onClick={countDown}
                aria-label="Decrease hours"
              >
                &minus;
              </button>
              <span className={css.stepValue}>{count}</span>
              <button
                type="button"
                className={css.stepBtn}
                onClick={countUp}
                aria-label="Increase hours"
              >
                +
              </button>
            </div>
          </div>

          <div className={[css.infoCard, css.totalCard].join(' ')}>
            <div className={[css.infoIcon, css.totalIcon].join(' ')}>
              <FontAwesomeIcon icon={faReceipt} />
            </div>
            <div className={css.infoBody}>
              <div className={css.infoTitle}>Total</div>
              <div className={css.infoDesc}>Charged when you confirm booking</div>
            </div>
            <span className={css.totalValue}>${total}</span>
          </div>
        </div>

        <button
          type="button"
          className={css.submitButton}
          onClick={() => handleBookingSubmit({ quantity: count, currentListing })}
        >
          Proceed to payment
          <FontAwesomeIcon className={css.submitIcon} icon={faArrowRight} />
        </button>
      </div>
    </div>
  );
}

export default withRouter(BookingModal);
